export default __webpack_public_path__ + "static/LeituraSansTwo-Black-a1a37e29e9e1da0592a847991412f964.woff2";